import { cloneDeep } from 'lodash';
import { Quotation } from 'src/types';

export const itemsOrganizer = (quotationItems: Quotation[]) => {
  // Clone to avoid modifying original data
  const clonedItems = cloneDeep(quotationItems);

  // Step 1: Filter out empty products
  const validItems = clonedItems.filter(
    (item: any) => !!item.product?.product_name
  );

  // Step 2: Normalize data and set warnings/custom flags
  const normalizedItems = validItems.map((item: any) => {
    const product = item.product;

    const isCustom =
      (!product.category_id &&
        !product.product_id &&
        product.retail_price === 0) ||
      !product.retail_price;

    return {
      ...item,
      product: {
        ...product,
        retail_price: product.retail_price || 0
      },
      custom: isCustom || item.custom,
      warning_note:
        !product.category_name && !isCustom ? 'Category Needed.' : undefined
    };
  });

  // Step 3: Combine duplicates (same product_id, name, and price)
  const mergedItems = normalizedItems.reduce((acc: any, item: any) => {
    const existingItem = acc.find(
      (existing: any) =>
        existing.product.product_id === item.product.product_id &&
        existing.product.product_name === item.product.product_name &&
        existing.product.retail_price === item.product.retail_price
    );

    existingItem ? (existingItem.quantity += item.quantity) : acc.push(item);

    return acc;
  }, []);
  return mergedItems;
};
